import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { NotifyService } from "../services/notify-service";
export function RLEntityAssetsTable() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-assets-table.html"),
        controller: RLEntityAssetsTableController,
        controllerAs: "eatVM",
        bindToController: true,
        scope: {
            rows: "=",
            rowChildCounts: "=",
            parentEntityID: "=parentEntityId",
            page: "=",
            pageCount: "=",
            pageSize: "=",
            numFound: "=",
            onViewEntity: "&?",
            onRemoveAsset: "&?",
            selectedEntityID: "=?selectedEntityId",
            canEdit: "=?",
            locked: "=?"
        }
    };
    return directive;
}

export class RLEntityAssetsTableController {
    static $inject = ["$scope", "notifyService"];

    rows: Models.IEntityRelationshipPair[];
    rowChildCounts: { [key: number]: number };
    parentEntityID: string;
    rootLevel: number;
    page: number;
    pageCount: number;
    pageSize: number;
    numFound: number;
    onViewEntity: Function;
    onRemoveAsset: Function;
    selectedEntityID: string;
    canEdit: boolean;
    locked: boolean;

    constructor(private $scope: ng.IScope, private notifyService: NotifyService) {

        this.rootLevel = 0;
    }

    ViewEntity(entityID: string) {
        if (this.onViewEntity != null) {
            this.onViewEntity({ entityID: entityID });
        }
    }

    RemoveAsset(asset: Models.IEntityRelationshipPair) {
        if (this.onRemoveAsset != null) {
            this.onRemoveAsset({ asset: asset });
        }
    }
}
